import React from 'react';
import {
  FEATURE_ALIGNMENT_CONTROL,
  FEATURE_BORDER_RADIUS_CONTROL,
  FEATURE_DIMENSIONS_CONTROL,
  FEATURE_OPACITY_CONTROL,
  FEATURE_PLAYBACKRATE_CONTROL,
  FEATURE_POSITION_CONTROL,
  FEATURE_ROTATION_CONTROL,
  FEATURE_SOURCE_CONTROL,
} from '../flags';
import { WebpItem } from '../items/webp/webp-item-type';
import { GeneralHeader } from '@crabs-ai/ds-react';
import { AlignmentControls } from './controls/alignment-controls';
import { BorderRadiusControl } from './controls/border-radius-controls';
import { DimensionsControls } from './controls/dimensions-controls';
import { OpacityControls } from './controls/opacity-controls';
import { PlaybackRateControls } from './controls/playback-rate-controls';
import { PositionControl } from './controls/position-control';
import { RotationControl } from './controls/rotation-controls';
import { SourceControls } from './controls/source-info/source-info';
import { AnimationControls } from './controls/animation-controls';
import { EMPTY_ANIMATIONS } from '../items/animation/animation-item-type';
import { useTranslations } from 'next-intl';

const WebpInspectorUnmemoized: React.FC<{
  item: WebpItem;
  isMulti?: boolean;
  collapseAllTrigger?: number;
  expandAllTrigger?: number;
}> = ({ item, isMulti, collapseAllTrigger = 0, expandAllTrigger = 0 }) => {
  const t = useTranslations();

  return (
    <div>
      {/* Animation 섹션 */}
      <AnimationControls
        itemId={item.id}
        animations={item.animations ?? EMPTY_ANIMATIONS}
        durationInFrames={item.durationInFrames}
        collapseAllTrigger={collapseAllTrigger}
        expandAllTrigger={expandAllTrigger}
      />
      <div className="flex flex-col gap-2xs">
        {FEATURE_SOURCE_CONTROL && !isMulti && <SourceControls item={item} />}
        <div>
          <GeneralHeader
            size="sm"
            title={'위치 및 모양'}
          />
          <div className="flex flex-col gap-4xs px-md">
            {FEATURE_ALIGNMENT_CONTROL && (
              <AlignmentControls itemId={item.id} />
            )}
            {FEATURE_POSITION_CONTROL && <PositionControl itemId={item.id} />}
            {FEATURE_DIMENSIONS_CONTROL && (
              <DimensionsControls itemId={item.id} />
            )}
            {FEATURE_ROTATION_CONTROL && (
              <RotationControl
                rotation={item.rotation}
                itemId={item.id}
              />
            )}
            <div className={'flex w-full justify-between gap-4xs'}>
              {FEATURE_OPACITY_CONTROL && (
                <div className={'w-full'}>
                  <OpacityControls
                    opacity={item.opacity}
                    itemId={item.id}
                  />
                </div>
              )}
              {FEATURE_BORDER_RADIUS_CONTROL && (
                <BorderRadiusControl
                  borderRadius={item.borderRadius}
                  itemId={item.id}
                />
              )}
            </div>
          </div>
          {FEATURE_PLAYBACKRATE_CONTROL && (
            <div>
              <GeneralHeader
                size="sm"
                title={t('Editor.inspector.gif-setting')}
              />
              <div className={'px-md'}>
                <PlaybackRateControls
                  playbackRate={item.playbackRate}
                  itemId={item.id}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export const WebpInspector = React.memo(WebpInspectorUnmemoized);
